import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OnlineyogaService } from './onlineyoga.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingLoginService } from '../booking-login/booking-login.service';
import { DatePipe } from '@angular/common';
import { LoginService } from '../loginone/login.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ValidateService } from 'app/shared/validate.service';
import { GlobalService } from 'app/shared/global.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/service/auth/auth.service';
import { CommonService } from 'app/shared/common.service';
import { PaymentGatewayService } from '../booking-login/payment-gateway.service';
import { MiscService } from 'app/shared/misc.service';
import { PickDateAdapter, PICK_FORMATS } from "app/shared/format-datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
declare var Razorpay: any;
@Component({
  selector: 'app-onlineyoga',
  templateUrl: './onlineyoga.component.html',
  styleUrls: ['./onlineyoga.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ],
})
export class OnlineyogaComponent implements OnInit {

  items = [];
  public currentDate = new Date();
  datePipe = new DatePipe("en-US");
  Today = '';
  isInProgress = false;
  page = 1;
  filters: string = '';
  Prefix = [];
  LanguageType = [];
  errorMessage: string = '';
  PaymentServiceProvider = 'Razorpay Payment Gateway';
  States = [];
  City = [];
  District = [];
  CancellationReasonList = [];
  isPaymentHistory = false;
  SelectedOnlinePatientRegistrationID = 0;
  GuestQuetionaridetails = [];
  genders = [
    { value: 'MALE', description: 'MALE' },
    { value: 'FEMALE', description: 'FEMALE' },
    { value: 'TRANSGENDER', description: 'TRANSGENDER' }
  ];

  advanceReceiptBook = 0;
  donationReceiptBook = 0;
  configurationDetaild = [];
  bookingAmount = 0;
  PaymentVerificationRequest = {
    'ThirdpartyPaymentID': '',
    'ThirdpartyPaymentOrderID': '',
    'razorpay_signature': '',
    'ClientSecret': ''
  };

  CarmePaymentGateway_key = "";
  CarmePaymentGateway_secret = "";
  CarmeApplication_ClientID = "";
  CarmeApplication_ClientSecret = "";
  ClientPublic_Token = "";
  ClientAccess_Token = "";
  ClientRefresh_Token = "";
  ClientExpires_In = 0;
  ClientPaymentGatewayTypeID = 0;
  ClientState = "";
  PaymentGateway = 0;
  paymentGatewaydetails = [];
  ThirdpartyPaymentID = "";
  ThirdpartyPaymentOrderID = "";

  itemToEdit = {
    'OnlinePatientRegistrationID': '',
    'OnlineUserRegistrationID': 0,
    'UHID': 0,
    'Prefix': '',
    'FirstName': '',
    'MiddleName': '',
    'LastName': '',
    'OnlineUserName': '',
    'GSM': '',
    'UserGSM': '',
    'WAGSM': '',
    'DateOfBirth': '',
    'Age': '',
    'Gender': '',
    'Address': '',
    'City': '',
    'State': '',
    'Country': '',
    'Nationality': '',
    'District': '',
    'AadharNo': '',
    'PassportNo': '',
    'PinCode': '',
    'GuestEmail': '',
    'RelationWithUser': '',
    'MigratedToUHID': 0,
    'LogValue': '',
    'UserName': '',
    'PreferredLanguage': '',
    'BlackListed': false,
    'Activate': true,
  };

  itemToEditYogaBooking = {
    'Type': "YogaBooking",
    'PaymentID': 0,
    'ReceiptBookID': 0,
    'ReceiptNo': 0,
    'BookingID': 0,
    'YogaBatchID': 0,
    'Amount': 0,
    'RefundID': 0,
    'RefundAmount': 0,
    'YogaPackageName': '',
    'Sessions': '',
    'Instructor': '',
    'BatchTimeandDays': '',
    'Remark': '',
    'ThirdpartyPaymentOrderID': '',
    'ThirdpartyPaymentID': '',
    'CarmePaymentGateway_key': this.CarmePaymentGateway_key,
    'CarmePaymentGateway_secret': this.CarmePaymentGateway_secret,
    'SelectedOnlinePatientRegistrationID': 0,
    'BookingDate': "",
    'YogaStartDate': '',
    'OnlinePatientRegistrationID': '',
    'OnlineUserRegistrationID': 0,
    'UHID': 0,
    'PatientID': 0,
    'PatientFullName': '',
    'WAGSM': '',
    'MigratedToUHID': 0,
    'CarryforwardBookingID': 0,
    'CarryForwardAmount': 0,
    'LogValue': '',
    'UserName': '',
    'BlackListed': false,
    'Activate': true,
    'ClientID': 2,
    'LocationID': 2,
    'BookingType': "",
    'DeductionAmount': 0,
    "Synchronized": false,
    'PaymentStatus': '',
    'BookingStatus': '',
  };

  constructor(
    public onlineyogaservice: OnlineyogaService,
    public bookingloginService: BookingLoginService,
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private toasterService: ToastrService,
    public translate: TranslateService,
    public validateService: ValidateService,
    public globals: GlobalService,
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private miscService: MiscService,
    public cdr: ChangeDetectorRef,
    private paymentGatewayService: PaymentGatewayService,
  ) { }

  trackByFn(index: number, item: any): any {
    return index; // Or return a unique identifier of the item
  }

  GetComponentID() {
    this.Today = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.miscService.getMiscellaneous('Prefix').subscribe(data => {
      this.Prefix = data as string[];
    });
    this.miscService.getMiscellaneous('LanguageType').subscribe(data => {
      this.LanguageType = data as string[];
    });
    this.miscService.getMiscellaneous('CancellationReason').subscribe(data => {
      this.CancellationReasonList = data as string[];
    });
    this.GetCountryandNationality();
    this.getStateList();
    this.GetConfigurationDetails();
    this.LoadGuest();
    this.GetAllYogaMaster();
  }

  // GetsigninDetails(Type) {
  //   this.issignin = false;

  //   if (Type == 'signin') {
  //     // this.issignin = true;
  //   } else if (Type == 'Addbutton') {
  //     this.issignin = true;
  //   }
  //   else {
  //     this.issignin = false;
  //   }
  // }

  CountryandNationality = [];
  // Get Country and Nationalty list from mstcountry
  GetCountryandNationality() {
    this.bookingloginService.GetCountryandNationality().subscribe(data => {
      this.CountryandNationality = data;
    });
  }

  //Getting State List
  getStateList() {
    this.commonService.GetStateList('State', '').subscribe(
      (data: any) => {
        this.States = data;
      }
    );
  }

  //Getting District List
  GetDistrictList(event) {
    let State = event.source.value;
    this.commonService.GetStateList('District', State).subscribe(
      (data: any) => {
        this.District = data;
      }
    );
  }

  //Getting City List
  GetCityList(event) {
    let State = this.itemToEdit.State;
    this.commonService.GetStateList('City', State).subscribe(
      (data: any) => {
        this.City = [];
        this.City = data;
      }
    );
  }

  YogaMaster = [];
  GetAllYogaMaster() {
    this.onlineyogaservice.GetAllYogaMaster(0).subscribe(data => {
      this.YogaMaster = data;
    });
  }

  // load Guest Detail data
  LoadGuest() { // OnlineUserRegistrationID
    this.isBookingHistory = false;
    this.isPaymentHistory = false;
    this.IsYogaBooking = false;
    this.bookingloginService.GuestDetail(0, true, this.globals.UserID).subscribe((data) => {
      if (data.length > 0) {
        this.items = data;
      }
    })
  }

  // Get configuration Details From mstclientconfiguration
  GetConfigurationDetails() {
    this.loginService.GetConfigurationDetails().subscribe(data => {
      this.configurationDetaild = data;
      // this.bookingAmount = this.configurationDetaild[0]["BookingAmount"];
      this.CarmePaymentGateway_key = this.configurationDetaild[0]["PaymentGateway_key"];
      this.CarmePaymentGateway_secret = this.configurationDetaild[0]["PaymentGateway_secret"];
      this.CarmeApplication_ClientID = this.configurationDetaild[0]["Application_ClientID"];
      this.CarmeApplication_ClientSecret = this.configurationDetaild[0]["Application_ClientSecret"];
      const paymentReceiptBook = this.configurationDetaild[0]["PaymentReceiptBook"] != undefined
        && this.configurationDetaild[0]["PaymentReceiptBook"] != "" ? this.configurationDetaild[0]["PaymentReceiptBook"].split(",") : "";
      if (paymentReceiptBook.length > 0) {
        this.advanceReceiptBook = +paymentReceiptBook[0];
        this.donationReceiptBook = +paymentReceiptBook[1];
      }
      this.GetPaymentGatewayDetails();
    });
  }

  // Getting Payment Gateway Details by ClientID and LocationID
  GetPaymentGatewayDetails() {
    this.PaymentGateway = 1;
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.PaymentGateway != 0) {
        this.paymentGatewayService.GetPaymentGatewayDetails(2, 2, this.PaymentGateway).subscribe(data => {
          this.paymentGatewaydetails = data as string[];
          if (this.paymentGatewaydetails.length > 0) {
            // for website
            this.ClientPaymentGatewayTypeID = this.paymentGatewaydetails[0]["PaymentGatewayTypeID"];
            this.ClientExpires_In = this.paymentGatewaydetails[0]["Expires_In"];
            this.ClientPublic_Token = this.paymentGatewaydetails[0]["Public_Token"];
            this.ClientAccess_Token = this.paymentGatewaydetails[0]["Access_Token"];
            this.ClientRefresh_Token = this.paymentGatewaydetails[0]["Refresh_Token"];
            this.ClientState = this.paymentGatewaydetails[0]["State"];
          } else {
            this.ClientPublic_Token = "";
            this.ClientAccess_Token = "";
            this.ClientRefresh_Token = "";
            this.ClientExpires_In = 0;
            this.ClientPaymentGatewayTypeID = 0;
            this.ClientState = "";
          }
        });
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetPaymentGatewayDetails();
    }
  }

  IsYogaBooking = false;
  GetcheckFunction(GuestName, OnlinePatientRegistrationID) {
    this.GetFormatedMasterData();
    let result = this.items.filter((x) => x["OnlinePatientRegistrationID"] == OnlinePatientRegistrationID);
    this.GuestQuetionaridetails = result;
    this.IsYogaBooking = true;
    this.UserEmail = this.GuestQuetionaridetails[0]['Email'];
    this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
    this.GuestName = GuestName;
  }

  yogaPackages: any[] = [];
  GetFormatedMasterData() {
    const grouped: any = {};
    this.YogaMaster.forEach(item => {
      if (!grouped[item.YogaPackageName]) {
        grouped[item.YogaPackageName] = {
          YogaPackageName: item.YogaPackageName,
          disease: item.Disease,
          sessions: [],
          instructor: item.Instructor,
          time: item.BatchTimeandDays
        };
      }

      grouped[item.YogaPackageName].sessions.push({
        duration: item.Sessions,
        YogaBatchID: item.YogaBatchID,
        amount: parseFloat(item.Amount)
      });
    });

    this.yogaPackages = Object.values(grouped);
  }

  batches = [
    {
      time: '',
      days: '',
      instructor: ''
    },
  ];

  IsYogaBookingDate = false;
  selectedPackage = [];
  selectedsession = [];
  GetYogaBooking(pkg, session) {
    this.generateUpcomingDates(7, this.Today); // next 7 days
    this.batches[0].time = pkg.time.split(' - ')[0];
    this.batches[0].days = pkg.time.split(' - ')[1];
    this.batches[0].instructor = pkg.instructor;
    this.IsYogaBookingDate = true;
    this.selectedPackage = pkg;
    this.selectedsession = session;
    this.itemToEditYogaBooking.YogaBatchID = session.YogaBatchID;
    this.itemToEditYogaBooking.YogaPackageName = pkg.YogaPackageName + (pkg.disease != '' ? '(' + pkg.disease + ')' : '');
    this.itemToEditYogaBooking.Sessions = session.duration;
    this.itemToEditYogaBooking.Instructor = pkg.instructor;
    this.itemToEditYogaBooking.BatchTimeandDays = pkg.time;
    this.bookingAmount = this.selectedsession["amount"];
  }

  upcomingDates: Date[] = [];
  generateUpcomingDates(days: number, date) {
    this.upcomingDates = [];
    const today = new Date(date);
    for (let i = 0; i < days; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      this.upcomingDates.push(date);
    }
  }

  isHoliday(date: Date): boolean {
    // Example: return true for Sundays
    return date.getDay() === 0;
  }

  IsMakePayment = false;
  SelectedYogaBookingDate = '';
  MakePayment(date) {
    this.IsMakePayment = true;
    this.SelectedYogaBookingDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.itemToEditYogaBooking.YogaStartDate = this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  isFinalPayment = false;
  FinalMakePayment() {
    this.isFinalPayment = true;
    this.itemToEditYogaBooking.ThirdpartyPaymentID = '';
    this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = '';
  }

  itemToEditRazorpayBookingAndYoga = {
    'Type': "YogaBooking",
    'MinBedCount': 0,
    'ReceiptBookID': 0,
    'BookingID': 0,
    'BookingCode': '',
    'YogaBatchID': 0,
    'Access_Token': '',
    'SelectedClassID': 0,
    'selectedAliesName': '',
    'PaymentGateway_key': this.CarmePaymentGateway_key,
    'PaymentGateway_secret': this.CarmePaymentGateway_secret,
    'AdmissionDuration': 0,
    'StartDate': '',
    'ExpectedArival': '',
    'OnlinePatientRegistrationID': 0,
    'PatientID': 0,
    'CarryforwardBookingID': 0,
    'CarryForwardAmount': 0,
    'DeductionAmount': 0,
    'Amount': 0,
    'Currency': 'INR',
    'Receipt': 'order_rcpt_123',
    'Notes': 'Hospital bill payment',
    'IsRoomBook': false,
  };

  isPaymentHandled = false;
  // make payment with razorpay
  GetRazorpay() {
    // document.getElementById('MakeFinalPayment')['disabled'] = true;
    this.PaymentVerificationRequest = {
      'ThirdpartyPaymentID': '',
      'ThirdpartyPaymentOrderID': '',
      'razorpay_signature': '',
      'ClientSecret': ''
    };
    this.ThirdpartyPaymentID = "";
    this.ThirdpartyPaymentOrderID = "";
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.ClientPublic_Token != "") {
        if (!this.isTokenExpired(this.ClientExpires_In)) {
          if (this.bookingAmount != 0 && this.ClientAccess_Token != "") {
            this.paymentGatewayService.createOrder(this.bookingAmount, this.CarmePaymentGateway_key, this.CarmePaymentGateway_secret, this.ClientAccess_Token).subscribe((order: any) => {
              if (order.id != null && order.id != "") {
                this.isPaymentHandled = false;
                const RozarpayOptions = {
                  amount: 100 * 100,
                  currency: 'INR',
                  name: 'Nisargopchar Ashram',
                  key: this.ClientPublic_Token,
                  order_id: order.id,
                  description: 'Advance Payment',
                  prefill: {
                    name: this.GuestQuetionaridetails[0]['FirstName'] + " " + this.GuestQuetionaridetails[0]['MiddleName'] + " " + this.GuestQuetionaridetails[0]['LastName'],
                    email: this.UserEmail,
                    contact: this.GuestQuetionaridetails[0].MobileNo,
                  },
                  theme: { color: '#6466e3' },
                  handler: (response: any) => {
                    this.itemToEditYogaBooking.ThirdpartyPaymentID = response.razorpay_payment_id;
                    this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = response.razorpay_order_id;

                    this.PaymentVerificationRequest.ThirdpartyPaymentID = response.razorpay_payment_id;
                    this.PaymentVerificationRequest.ThirdpartyPaymentOrderID = response.razorpay_order_id;
                    this.PaymentVerificationRequest.razorpay_signature = response.razorpay_signature;
                    this.PaymentVerificationRequest.ClientSecret = this.CarmeApplication_ClientSecret;
                    this.itemToEditYogaBooking.PaymentStatus = "Payment Successful";
                    this.toasterService.success("Record Save Successfully!!");
                    // Verify Payment Signature using ThirdpartyPaymentID, ThirdpartyPaymentOrderID
                    this.VerifyPaymentSignature();
                  },
                  modal: {
                    ondismiss: () => {
                      this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = order.id;
                      this.itemToEditYogaBooking.PaymentStatus = "Payment Cancel";
                      if (this.isPaymentHandled) return;
                      this.isPaymentHandled = true;
                      this.SaveFailedAndCancelPayment();
                    }
                  }
                };
                // ? Open Razorpay Checkout on Billing Staff Monitor (Left)
                const rzp = new Razorpay(RozarpayOptions);

                rzp.on('payment.failed', (response: any) => {
                  if (this.isPaymentHandled) return;
                  this.isPaymentHandled = true;
                  const failedPaymentDetails = {
                    code: response.error.code,
                    description: response.error.description,
                    source: response.error.source,
                    step: response.error.step,
                    reason: response.error.reason,
                    order_id: response.error.metadata?.order_id && response.error.metadata.order_id !== ''
                      ? response.error.metadata.order_id
                      : order.id,
                    payment_id: response.error.metadata?.payment_id || '',
                  };
                  this.itemToEditYogaBooking.ThirdpartyPaymentID = failedPaymentDetails.payment_id;
                  this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = failedPaymentDetails.order_id;
                  this.itemToEditYogaBooking.PaymentStatus = "Payment Failed";
                  //this.SaveFailedAndCancelPayment();

                });

                rzp.open(); // Opens checkout for billing staff
              }
            });
          } else {
            this.toasterService.warning("Something went wrong");
          }
        } else {
          this.GetRazorpayRefreshToken();
          this.GetRazorpay();
        }
      } else {
        let PatientID = this.GuestQuetionaridetails[0]['PatientID'] == null || this.GuestQuetionaridetails[0]['PatientID'] == '' ? 0 : this.GuestQuetionaridetails[0]['PatientID'];
        if (this.bookingAmount != 0 && this.CarmePaymentGateway_key != "") {
          this.itemToEditRazorpayBookingAndYoga = {
            'Type': "YogaBooking",
            'MinBedCount': 0,
            'ReceiptBookID': this.advanceReceiptBook,
            'BookingID': 0,
            'BookingCode': '',
            'YogaBatchID': +this.itemToEditYogaBooking.YogaBatchID,
            'Access_Token': this.ClientAccess_Token,
            'PaymentGateway_key': this.CarmePaymentGateway_key,
            'PaymentGateway_secret': this.CarmePaymentGateway_secret,
            'AdmissionDuration': 0,
            'ExpectedArival': '',
            'StartDate': this.itemToEditYogaBooking.YogaStartDate,
            'SelectedClassID': 0,
            'selectedAliesName': '',
            'OnlinePatientRegistrationID': this.SelectedOnlinePatientRegistrationID,
            'PatientID': PatientID,
            'CarryforwardBookingID': 0,
            'CarryForwardAmount': 0,
            'DeductionAmount': 0,
            'Amount': this.bookingAmount,
            'Currency': 'INR',
            'Receipt': 'order_rcpt_123',
            'Notes': 'Hospital bill payment',
            'IsRoomBook': false,
          };
          this.paymentGatewayService.CreateOrderWithKeySecret(this.itemToEditRazorpayBookingAndYoga).subscribe((order: any) => {
            if (order.id != null && order.id != "") {
              this.isPaymentHandled = false;
              const RozarpayOptions = {
                amount: 100 * 100,
                currency: 'INR',
                name: 'Nisargopchar Ashram',
                key: this.CarmePaymentGateway_key,
                order_id: order.id,
                description: 'Advance Payment',
                prefill: {
                  name: this.GuestQuetionaridetails[0]['FirstName'] + " " + this.GuestQuetionaridetails[0]['MiddleName'] + " " + this.GuestQuetionaridetails[0]['LastName'],
                  email: this.UserEmail,
                  contact: this.GuestQuetionaridetails[0].MobileNo,
                },
                theme: { color: '#6466e3' },
                handler: (response: any) => {
                  this.itemToEditYogaBooking.ThirdpartyPaymentID = response.razorpay_payment_id;
                  this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = response.razorpay_order_id;

                  this.PaymentVerificationRequest.ThirdpartyPaymentID = response.razorpay_payment_id;
                  this.PaymentVerificationRequest.ThirdpartyPaymentOrderID = response.razorpay_order_id;
                  this.PaymentVerificationRequest.razorpay_signature = response.razorpay_signature;
                  this.PaymentVerificationRequest.ClientSecret = this.CarmeApplication_ClientSecret;
                  this.itemToEditYogaBooking.PaymentStatus = "Payment Successful";
                  this.toasterService.success("Record Save Successfully!!");
                  this.isFinalPayment = false;
                  this.IsMakePayment = false;
                  this.IsYogaBooking = false;
                  this.IsYogaBookingDate = false;
                  this.itemToEditYogaBooking.ThirdpartyPaymentID = '';
                  this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = '';
                  this.LoadGuest();
                  // Verify Payment Signature using ThirdpartyPaymentID, ThirdpartyPaymentOrderID
                  //  this.VerifyPaymentSignature();

                  //this.SaveYogaBooking();
                },
                modal: {
                  ondismiss: () => {
                    this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = order.id;
                    this.itemToEditYogaBooking.PaymentStatus = "Payment Cancel";
                    if (this.isPaymentHandled) return;
                    this.isPaymentHandled = true;
                    this.SaveFailedAndCancelPayment();
                  }
                }
              };
              // ? Open Razorpay Checkout on Billing Staff Monitor (Left)
              const rzp = new Razorpay(RozarpayOptions);

              rzp.on('payment.failed', (response: any) => {
                if (this.isPaymentHandled) return;
                this.isPaymentHandled = true;
                const failedPaymentDetails = {
                  code: response.error.code,
                  description: response.error.description,
                  source: response.error.source,
                  step: response.error.step,
                  reason: response.error.reason,
                  order_id: response.error.metadata?.order_id && response.error.metadata.order_id !== ''
                    ? response.error.metadata.order_id
                    : order.id,
                  payment_id: response.error.metadata?.payment_id || '',
                };
                this.itemToEditYogaBooking.ThirdpartyPaymentID = failedPaymentDetails.payment_id;
                this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = failedPaymentDetails.order_id;
                this.itemToEditYogaBooking.PaymentStatus = "Payment Failed";
                //this.SaveFailedAndCancelPayment();

              });

              rzp.open(); // Opens checkout for billing staff
            }
          });
        } else {
          this.toasterService.warning("Something went wrong");
        }
      }



    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetRazorpay();
    }
  }

  // Save Failed And Cancel Payment Entery in trnpayment
  SaveFailedAndCancelPayment() {
    this.itemToEditYogaBooking.BookingID = 0;
    this.itemToEditYogaBooking.BookingStatus = 'Unutilized by the Patient/guest';
    this.itemToEditYogaBooking.UHID = +this.GuestQuetionaridetails[0]['UHID'];
    this.itemToEditYogaBooking.PatientFullName = this.GuestQuetionaridetails[0]['Prefix'] + ' ' + this.GuestQuetionaridetails[0]['FirstName'] + ' ' + this.GuestQuetionaridetails[0]['MiddleName'] + ' ' + this.GuestQuetionaridetails[0]['LastName'];
    this.itemToEditYogaBooking.WAGSM = this.GuestQuetionaridetails[0]['WAGSM'];
    this.itemToEditYogaBooking.PatientID = this.GuestQuetionaridetails[0]['PatientID'];
    this.itemToEditYogaBooking.CarmePaymentGateway_key = this.CarmePaymentGateway_key;
    this.itemToEditYogaBooking.CarmePaymentGateway_secret = this.CarmePaymentGateway_secret;
    this.itemToEditYogaBooking.BookingType = "Online";
    this.itemToEditYogaBooking.ClientID = 2;
    this.itemToEditYogaBooking.LocationID = 2;
    this.itemToEditYogaBooking.SelectedOnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
    this.itemToEditYogaBooking.BookingDate = this.Today;
    this.itemToEditYogaBooking.ReceiptBookID = this.advanceReceiptBook;
    this.itemToEditYogaBooking.Amount = this.bookingAmount;

    this.itemToEditYogaBooking.CarryforwardBookingID = 0;
    this.itemToEditYogaBooking.CarryForwardAmount = 0;



    this.itemToEditYogaBooking.LogValue = 'OnlinePatientRegistrationID: ' + this.itemToEditYogaBooking.OnlinePatientRegistrationID +
      ' ,YogaBookingID: ' + this.itemToEditYogaBooking.BookingID +
      ' ,YogaBookingDate: ' + this.Today;

    this.bookingloginService.SaveFailedAndCancelPayment(this.itemToEditYogaBooking).subscribe((data) => {
      if (data == "OK") {
        this.itemToEditYogaBooking.ThirdpartyPaymentID = '';
        this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = '';
      }
    });
  }

  // getting razorpay refresh token
  GetRazorpayRefreshToken() {
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      this.paymentGatewayService.GetRazorpayRefreshToken(this.CarmeApplication_ClientID, this.CarmeApplication_ClientSecret, this.ClientRefresh_Token, this.ClientPaymentGatewayTypeID, this.globals.ClientID, this.globals.LocationID).subscribe((data: any) => {
        if (data == "OK") {
          this.GetPaymentGatewayDetails();
        }
      });
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetRazorpayRefreshToken();
    }
  }

  isTokenExpired(expiresIn: number): boolean {
    const currentTime = new Date().getTime();
    const expirationTime = currentTime + expiresIn * 1000;
    return expirationTime < currentTime; // Returns true if expired
  }

  // Razorpay Verify Payment Signature
  VerifyPaymentSignature() {
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.PaymentVerificationRequest.ThirdpartyPaymentID != "" && this.PaymentVerificationRequest.ThirdpartyPaymentOrderID != ""
        && this.PaymentVerificationRequest.razorpay_signature != "" && this.PaymentVerificationRequest.ClientSecret != "") {
        this.paymentGatewayService.VerifyPaymentSignature(this.PaymentVerificationRequest).subscribe((data) => {
          this.isInProgress = false;
          if (data != undefined && data != null) {
            if (data == 'OK') {
              //this.SaveYogaBooking();
            }
            else {
              this.globals.ShowToastrMessage("error", 'Something went wrong');
            }
          }
          this.isInProgress = false;
        });
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.VerifyPaymentSignature();
    }
  }

  // Add new Guest
  AddNew(content) {
    this.itemToEdit = {
      'OnlinePatientRegistrationID': '',
      'OnlineUserRegistrationID': 0,
      'UHID': 0,
      'Prefix': this.configurationDetaild[0]["Prefix"],
      'FirstName': '',
      'MiddleName': '',
      'LastName': '',
      'OnlineUserName': '',
      'GSM': '',
      'UserGSM': '',
      'WAGSM': '',
      'DateOfBirth': this.datePipe.transform(this.Today, 'yyyy-MM-dd'),
      'Age': '',
      'Gender': '',
      'Address': '',
      'City': '',
      'State': '',
      'Country': '',
      'Nationality': '',
      'District': '',
      'AadharNo': '',
      'PassportNo': '',
      'PinCode': '',
      'GuestEmail': '',
      'RelationWithUser': '',
      'MigratedToUHID': 0,
      'LogValue': '',
      'PreferredLanguage': '',
      'UserName': this.globals.UserName,
      'BlackListed': false,
      'Activate': true,
    };
    this.isValidAadhaar = true;
    this.modalService.open(content, { backdrop: 'static', size: 'xl', centered: true, keyboard: false });
  }

  GetPaymentHistory(OnlinePatientRegistrationID) {
    this.isPaymentHistory = true;
    this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
  }

  SaveYogaBooking() {
    this.itemToEditYogaBooking.BookingStatus = 'Unutilized by the Patient/guest';
    this.itemToEditYogaBooking.UHID = +this.GuestQuetionaridetails[0]['UHID'];
    this.itemToEditYogaBooking.PatientFullName = this.GuestQuetionaridetails[0]['Prefix'] + ' ' + this.GuestQuetionaridetails[0]['FirstName'] + ' ' + this.GuestQuetionaridetails[0]['MiddleName'] + ' ' + this.GuestQuetionaridetails[0]['LastName'];
    this.itemToEditYogaBooking.WAGSM = this.GuestQuetionaridetails[0]['WAGSM'];
    this.itemToEditYogaBooking.PatientID = this.GuestQuetionaridetails[0]['PatientID'];
    this.itemToEditYogaBooking.CarmePaymentGateway_key = this.CarmePaymentGateway_key;
    this.itemToEditYogaBooking.CarmePaymentGateway_secret = this.CarmePaymentGateway_secret;
    this.itemToEditYogaBooking.BookingType = "Online";
    this.itemToEditYogaBooking.ClientID = 2;
    this.itemToEditYogaBooking.LocationID = 2;
    this.itemToEditYogaBooking.SelectedOnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
    this.itemToEditYogaBooking.BookingDate = this.Today;
    this.itemToEditYogaBooking.ReceiptBookID = this.advanceReceiptBook;
    this.itemToEditYogaBooking.Amount = this.bookingAmount;
    this.onlineyogaservice.SaveYogaBooking(this.itemToEditYogaBooking).subscribe((data) => {
      if (data.includes("OK")) {
        this.LoadGuest();
        this.isFinalPayment = false;
        this.IsMakePayment = false;
        this.IsYogaBooking = false;
        this.IsYogaBookingDate = false;
        this.toasterService.success("Record Save Successfully!!");
        this.itemToEditYogaBooking.ThirdpartyPaymentID = '';
        this.itemToEditYogaBooking.ThirdpartyPaymentOrderID = '';
      }
      else {
        this.toasterService.error('Something went wrong');
      }
    });
  }

  // Save Guest
  SaveGuest() {
    // this.IsEmailVerified &&
    if (this.itemToEdit.FirstName != '' && this.itemToEdit.LastName != '' && this.itemToEdit.Gender != '' && this.itemToEdit.Address != '' && this.itemToEdit.Country != '' &&
      ((this.itemToEdit.Nationality == 'Indian' && this.itemToEdit.AadharNo.length == 12 && this.isValidAadhaar) || (this.itemToEdit.Nationality != 'Indian' && this.itemToEdit.PassportNo != ''))) {
      // Check DOB is Current Date or not
      if (this.itemToEdit.DateOfBirth != "" && this.itemToEdit.DateOfBirth != null && this.itemToEdit.DateOfBirth != this.Today) {
        const ageData = this.calculateAge(this.itemToEdit.DateOfBirth, this.Today); // Get age details

        // Strict check: If age is 70 years and 1 day or more, don't allow saving
        if (ageData.years < 5 || (ageData.years === 5 && (ageData.months === 0 && ageData.days === 0)) || ageData.years > 75 || (ageData.years === 75 && (ageData.months > 0 || ageData.days > 0))) {
          alert("Guests must be at least 5 years old and younger than 75 years. For assistance, please contact the Nisargopchar team or email us at enquiry@nisargopacharashram.org.");
          return; // Stop execution
        }
        this.isInProgress = true;
        // this.itemToEdit.OnlineUserName = this.OnlineUserRegistration.MiddleName != '' || this.OnlineUserRegistration.MiddleName != null ?
        //   this.OnlineUserRegistration.FirstName + ' ' + this.OnlineUserRegistration.MiddleName + ' ' + this.OnlineUserRegistration.LastName :
        //   this.OnlineUserRegistration.FirstName + ' ' + this.OnlineUserRegistration.LastName;
        this.itemToEdit.DateOfBirth = this.datePipe.transform(this.itemToEdit.DateOfBirth, 'yyyy-MM-dd');
        this.itemToEdit.OnlineUserRegistrationID = this.globals.UserID;
        // this.itemToEdit.UserGSM = this.OnlineUserRegistration.WhatsAppNo;
        this.itemToEdit.LogValue = ' ,OnlinePatientRegistrationID: ' + this.itemToEdit.OnlinePatientRegistrationID +
          ' ,OnlineUserRegistrationID: ' + this.itemToEdit.OnlineUserRegistrationID +
          ' ,FirstName: ' + this.itemToEdit.FirstName +
          ' ,MiddleName: ' + this.itemToEdit.MiddleName +
          ' ,LastName: ' + this.itemToEdit.LastName +
          ' ,DateOfBirth: ' + this.itemToEdit.DateOfBirth +
          ' ,Gender: ' + this.itemToEdit.Gender +
          ' ,Address: ' + this.itemToEdit.Address +
          ' ,PinCode: ' + this.itemToEdit.PinCode +
          ' ,PreferredLanguage' + this.itemToEdit.PreferredLanguage;
        this.bookingloginService.SaveGuest(this.itemToEdit).subscribe((data) => {
          if (data != undefined && data.length > 0) {
            if (data == "Ok") {
              this.toasterService.success("Record Save Successfully!!");
              this.LoadGuest();
              // Saved Succesfully
              document.getElementById('btnClose').click(); // call close button
            }
            // else if (data.includes("Found$")) {
            //   // Found with other ID
            //   // this.toasterService.warning('This patient/guest has already been registered in our system !!');
            //   const cnf = confirm("This patient/guest has already been registered in our system. If you want to transfer patient/Guest then go ahead!!");
            //   if (cnf) {
            //     this.TransferConfirmation = true;
            //     this.TransferGuestNumber = data.split('$')[1];
            //     this.TransferGuestEmail = data.split('$')[2];
            //     this.TransferPatientGuestID = data.split('$')[3];
            //     //this.toasterService.success('Prosessing to transfer patient/Guest....');
            //   }
            // }
            else if (data == "FoundSameID") {
              // Found with Same ID
              this.toasterService.warning('This patient/guest has already been registered in our system under you !!');
            } else {
              this.toasterService.error('Something went wrong');
            }
            this.isInProgress = false;
          } else {
            this.toasterService.error('Something went wrong');
            this.isInProgress = false;
          }
        });
      } else {
        this.toasterService.warning("Please select date of birth !!");
        this.isInProgress = false;
      }
    } else {
      this.toasterService.warning("Please enter mandatory fields and verify email !!");
    }
  }

  BookingHistory = [];
  GuestName = "";
  UserEmail = '';
  isBookingHistory = false;
  // Get Guest all booking history
  GetYogaBookingHistory(OnlinePatientRegistrationID) {
    this.BookingHistory = [];
    let result = this.items.filter((x) => x["OnlinePatientRegistrationID"] == OnlinePatientRegistrationID);
    this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
    this.GuestQuetionaridetails = result;
    this.GuestName = result[0]['GuestName'];
    this.UserEmail = result[0]['Email'];
    this.onlineyogaservice.GetYogaBookingHistory(OnlinePatientRegistrationID).subscribe((data) => {
      this.isBookingHistory = true;
      this.BookingHistory = data;
    });
  }

  isValidAadhaar = true;
  ValidateAadhaar(aadhaarNumber): boolean {
    if (aadhaarNumber.trim() === "") {
      this.isValidAadhaar = false;
      return false;
    }
    else {
      if (!/^[2-9]\d{11}$/.test(aadhaarNumber)) // checking if aadhaar number is 12 digits and should not start with 0 and 1
      {
        this.isValidAadhaar = false;
        return false;
      }
      //calling function to check VerhoeffAlgorithm
      this.isValidAadhaar = VerhoeffAlgorithm.validateVerhoeff(aadhaarNumber);
      return this.isValidAadhaar;
    }
  }

  isWAGSM = true;
  isUserWAGSM = true;
  // if check then GSM and WAGSM is same
  GetGSMasWAGSM(params, type) {
    if (type == 'Guest') {
      this.isUserWAGSM = !this.isUserWAGSM;
      if (params == true) {
        this.itemToEdit.WAGSM = this.itemToEdit.GSM;
      } else {
        this.itemToEdit.WAGSM = '';
      }
    }
  }

  // Function to calculate ages
  calculateAge(dob: string, currentD: string): { years: number, months: number, days: number } {
    const birthDate = new Date(dob);
    const currentDate = new Date(currentD);
    let years = currentDate.getFullYear() - birthDate.getFullYear();
    let months = currentDate.getMonth() - birthDate.getMonth();
    let days = currentDate.getDate() - birthDate.getDate();

    // Adjust if birth month/day hasn't passed yet this year
    if (days < 0) {
      months -= 1;
      const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }
    this.itemToEdit.Age = years + ' Y ' + months + ' M ' + days + ' D';
    return { years, months, days };
  }

  // Converting Text into UpperCase
  UpperCase(str, fieldname) {
    const result = this.validateService.UpperCase(str);
    this.itemToEdit[fieldname] = result;
  }
  // trim the spaces from strings
  TrimName(str, fieldname) {
    const result = str.trim();
    this.itemToEdit[fieldname] = result;
  }

  validations: string[] = [];
  // to set fields mandatory
  SetRequiredFields() {
    for (let i = 0; i < this.validations.length; i++) {
      if (this.validations[i]['IsMandatory'] == true) {
        const append = '<i class="text-danger"> *</i>';
        document.getElementById('lbl' + this.validations[i]['ControlID'])['innerHTML'] += append;
      }
    }
  }

  // to set Aadhar or Passport Mandatory on Nationality
  SetMandatoryAadharandPassport() {
    const append = '<i class="text-danger"> *</i>';

    if (this.itemToEdit.Nationality === 'Indian') {
      // Remove * from Passport and add * to Aadhaar
      document.getElementById('lblPassportNo').innerHTML =
        document.getElementById('lblPassportNo').innerHTML.replace(append, '');

      if (!document.getElementById('lblAadharNo').innerHTML.includes(append)) {
        document.getElementById('lblAadharNo').innerHTML += append;
      }
    } else {
      this.isValidAadhaar = true;
      // Remove * from Aadhaar and add * to Passport
      document.getElementById('lblAadharNo').innerHTML =
        document.getElementById('lblAadharNo').innerHTML.replace(append, '');

      if (!document.getElementById('lblPassportNo').innerHTML.includes(append)) {
        document.getElementById('lblPassportNo').innerHTML += append;
      }
    }
  }

  // Getting Checked Is User Token Same Or Not
  GetCheckUserTokenValidOrNot() {
    this.commonService.GetCheckUserTokenValidOrNot().subscribe((result) => {
      if (result) {
        //   if (document.querySelector('#sideNavMenu > aside').classList.contains("ng-sidebar--opened")) {
        //     document.getElementById("toggleButton").click();
        //   }
        // Getting Token Expires Or Not
        const tokenExpires = this.authService.isTokenExpired();
        if (tokenExpires) {
          // Token Expires
          // Getting New Token
          this.GetRefreshToken();
          // Getting Checked Is User Token Same Or Not
          this.GetCheckUserTokenValidOrNot();
        } else {
          // Getting Token Expires Or Not
          // Token Is Valid
          this.GetComponentID();
        }
      } else {
        // Token is not same so loggin out user
        this.authService.logOut();
      }
    });
  }

  // Getting Refresh Token
  GetRefreshToken(): void {
    this.authService.getRefreshToken().subscribe((data) => {
      if (data != null || data != "") {
        this.authService.setToken(data);
      } else {
        this.authService.logOut();
      }
    });
  }

  ngOnInit(): void {
    this.globals.LastVisitedComponent = this.router.url;
    if (this.globals.UserName == '') {
      this.router.navigate(['/session/booking-login/booking-login-register']);
    }
    this.GetComponentID();
  }

  // Show Back button
  GetBack() {
    if (this.isFinalPayment) {
      this.isFinalPayment = false;
    }
    else if (this.IsMakePayment) {
      this.IsMakePayment = false;
    }
    // Hide Yoga Booking Dates
    else if (this.IsYogaBookingDate) {
      this.IsYogaBookingDate = false;
    }
    // Hide payment History
    else if (this.isPaymentHistory && this.globals.UserName != "" && !this.globals.isPaymentDetails) {
      this.isPaymentHistory = false;
    }
    // Hide payment details and show
    else if (this.isPaymentHistory && this.globals.UserName != "" && this.globals.isPaymentDetails) {
      this.isPaymentHistory = true;
      this.globals.isPaymentDetails = false;
    }
    else {
    }
  }

  // Function to disable Sundays
  disableSundays = (d: Date | null): boolean => {
    if (!d) return false;
    const day = d.getDay();
    return day !== 0; // Disable Sunday (0 = Sunday)
  }

}


// This class is used to validate Aadhaar number using VerhoeffAlgorithm
class VerhoeffAlgorithm {
  // Multiplication Table (D)
  private static d: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
  ];

  // Permutation Table (P)
  private static p: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
  ];

  // Inverse Table
  private static inv: number[] = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

  /**
   * Validates an Aadhaar number using Verhoeff Algorithm.
   * @param num - The Aadhaar number to validate.
   * @returns true if valid, false otherwise.
   */
  public static validateVerhoeff(num: string): boolean {
    let c = 0;
    const myArray = this.stringToReversedIntArray(num);

    for (let i = 0; i < myArray.length; i++) {
      c = this.d[c][this.p[i % 8][myArray[i]]];
    }
    return c === 0;
  }

  /**
   * Converts a string into a reversed integer array.
   * @param num - The string to convert.
   * @returns A reversed integer array.
   */
  private static stringToReversedIntArray(num: string): number[] {
    const myArray: number[] = num.split('').map((digit) => parseInt(digit, 10));
    return this.reverse(myArray);
  }

  /**
   * Reverses an array of integers.
   * @param myArray - The array to reverse.
   * @returns The reversed array.
   */
  private static reverse(myArray: number[]): number[] {
    return myArray.reverse();
  }
}
